import styled from "styled-components";

export const PageWrapper = styled.div`
  padding: 25px;
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PageTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
`;

export const AddButton = styled.button`
  background: transparent;
  border: none;
  color: #5a4bff;
  font-weight: 600;
  cursor: pointer;
`;

export const SectionTitle = styled.h3`
  margin-top: 35px;
  margin-bottom: 15px;
  font-size: 18px;
`;

export const PackagesGrid = styled.div`
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
`;

export const PackageCard = styled.div`
  width: 260px;
  background: #fff;
  border-radius: 16px;
  box-shadow: rgba(145, 158, 171, 0.08) 0px 12px 24px;
  overflow: hidden;
`;

export const PackageImage = styled.img`
  width: 100%;
  height: 160px;
  object-fit: cover;
`;

export const PackageBody = styled.div`
  padding: 14px;
`;

export const PackageTitle = styled.p`
  font-weight: 600;
`;

export const PackageMeta = styled.p`
  font-size: 13px;
  color: #637381;
  margin: 6px 0;
`;

export const PackagePrice = styled.p`
  font-weight: 700;
`;

/* Modal */

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;

export const ModalContainer = styled.div`
  width: 520px;
  height: 80vh;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  
`

export const ModalHeader = styled.div`
  padding: 16px 20px;
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
`;

export const ModalTitle = styled.h4`
  font-size: 18px;
`;

export const CloseBtn = styled.button`
  border: none;
  background: transparent;
  font-size: 22px;
  cursor: pointer;
`;

export const ModalBody = styled.div`
  padding: 20px;
  flex: 1;
  overflow-y: auto;
   /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: #1877f2 transparent;

  /* Chrome / Edge / Safari */
  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #1877f2;
    border-radius: 10px;
  }

  /* Make arrows INVISIBLE (not removed) */
  &::-webkit-scrollbar-button {
    background: transparent;
    height: 0;
    width: 0;
  }
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
`;

export const Input = styled.input`
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ddd;
`;

export const Select = styled.select`
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ddd;
`;

export const TextArea = styled.textarea`
  grid-column: span 2;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #ddd;
  resize: none;
`;

export const ModalFooter = styled.div`
  padding: 16px 20px;
  display: flex;
  flex-shrink: 0;
  justify-content: flex-end;
  gap: 12px;
  border-top: 1px solid #eee;
`;

export const PrimaryBtn = styled.button`
  background: #1877f2;
  color: #fff;
  border: none;
  padding: 10px 18px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
`;

export const SecondaryBtn = styled.button`
  background: #f1f1f1;
  border: none;
  padding: 10px 18px;
  border-radius: 8px;
  cursor: pointer;
`;
